export enum Variable {
	SignalRUrl = "signalRUrl",
	GatewayApiUrl = "gatewayApiUrl",
	BotApiUrl = "botApiUrl",
	AzureClients = "azureClients",
	ApiVersion = "apiVersion",
	Version = "version",
	Sentry = "sentry",
	GatewayApacApiUrl = "gatewayApacApiUrl"
}

const windowConfig: any = (window as any)["config"];

const variables = {
	[Variable.SignalRUrl]: windowConfig[Variable.SignalRUrl],
	[Variable.GatewayApiUrl]: `${windowConfig[Variable.GatewayApiUrl]}/${windowConfig[Variable.ApiVersion]}`,
	[Variable.BotApiUrl]: windowConfig[Variable.BotApiUrl],
	[Variable.AzureClients]: windowConfig[Variable.AzureClients],
	[Variable.ApiVersion]: windowConfig[Variable.ApiVersion],
	[Variable.Version]: windowConfig[Variable.Version],
	[Variable.Sentry]: windowConfig[Variable.Sentry],
	[Variable.GatewayApacApiUrl]: windowConfig[Variable.GatewayApacApiUrl]
};

export const envVariable = (variable: Variable): any => {
	return variables[variable];
};
